import { render, staticRenderFns } from "./CreateStudentForm.vue?vue&type=template&id=058ee4f3&scoped=true"
import script from "./CreateStudentForm.vue?vue&type=script&lang=js"
export * from "./CreateStudentForm.vue?vue&type=script&lang=js"
import style0 from "./CreateStudentForm.vue?vue&type=style&index=0&id=058ee4f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058ee4f3",
  null
  
)

export default component.exports